//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

import { useContext } from "react";

// custom pages
import config from "config/index";
import HandleApiResponse from "helpers/handleApiResponse";
import Context from "context/context";

function SessionMaintain() {
    const { state, dispatch } = useContext(Context);
    const { handleResponse, handleError } = HandleApiResponse();


    async function verifyToken() {
        try {
            const obj = {
                method: "GET",
                credentials: 'include',
                headers: {
                    "Content-Type": "application/json",
                },
            };
            let res = await fetch(
                `${config.host}/cdr-panel/api/session-maintain`,
                obj
            );

            return handleResponse(res);

        } catch (err) {
            handleError(err)
        }
    }

    async function extendSessionTime() {
        try {
            const obj = {
                method: "GET",
                credentials: 'include',
                headers: {
                    "Content-Type": "application/json",
                },
            };
            let res = await fetch(
                `${config.host}/cdr-panel/api/session-maintain/extend`,
                obj
            );

            return handleResponse(res);

        } catch (err) {
            handleError(err)
        }
    }

    async function logout() {
        try {
            const obj = {
                method: "GET",
                credentials: 'include',
                headers: {
                    "Content-Type": "application/json",
                },
            };
            let res = await fetch(
                `${config.host}/cdr-panel/api/session-maintain/logout`,
                obj
            );

            return handleResponse(res);

        } catch (err) {
            handleError(err)
        }
    }
    return {
        verifyToken,
        extendSessionTime,
        logout
    }
}

export default SessionMaintain